import { Component, OnInit, Input, inject } from "@angular/core";
import { NgClass } from "@angular/common";
import { TabComponentHelper } from "@app/shared/helpers/tab-component-helper";
import { TargetModule } from "@enums/document/TargetModule";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import { ToastrService } from "ngx-toastr";
import { NavigatorDocumentModel } from "@app/navigators/models/navigator-document-model";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { BusinessNavigatorRequestModel } from "@app/navigators/business-navigator/models/business-navigator-request-model";
import { BusinessNavigatorPermissionModel } from "@app/navigators/business-navigator/models/business-navigator-permission-model";
import { BusinessNavigatorDataService } from "@app/navigators/business-navigator/services/business-navigator-data.service";
import { firstValueFrom } from "rxjs";
import { DocumentManagerOldComponent } from "@app/shared/document-manager-old/document-manager-old.component";

// TODO create base class
@Component({
    selector: "business-documents",
    templateUrl: "./business-documents.component.html",
    styleUrls: ["./business-documents.component.scss"],
    imports: [NgClass, DocumentManagerOldComponent],
})
export class BusinessDocumentsComponent implements OnInit {
    private _businessDs = inject(BusinessNavigatorDataService);
    private _promptService = inject(CerrixPromptService);
    private _toastr = inject(ToastrService);

    @Input() requestModel: BusinessNavigatorRequestModel;
    @Input() permissions: BusinessNavigatorPermissionModel;
    @Input() cerrixTab: TabModel;

    documentTypeTargets = TargetModule.BusinessDimension;
    canEdit = true;
    isDocumentDirty = false;
    docModel: NavigatorDocumentModel = { documents: [] };

    isLoadingDocuments = false;
    public documentsLoaded = false;

    ngOnInit() {}

    async loadDocuments(force = false) {
        if (this.requestModel.businessID < 1 || (this.documentsLoaded && !force)) {
            return;
        }

        this.isLoadingDocuments = true;
        this._businessDs.getDocuments(this.requestModel).subscribe((docs) => {
            docs.parentId = this.requestModel.businessID;
            this.docModel = docs;
            this.isLoadingDocuments = false;
            this.documentsLoaded = true;
        });
    }

    async saveDocuments() {
        const prompt = this._promptService.loader("Uploading documents!");

        return firstValueFrom(this._businessDs
            .storeDocuments(this.docModel))
            .then((_) => {
                this._toastr.success("Documents have been uploaded!", "Success");
            })
            .finally(() => {
                prompt.close();
            });
    }

    checkDirty(): void {
        TabComponentHelper.toggleTabDirty(this.cerrixTab, "menuItemDocuments", true);
        this.isDocumentDirty = true;
    }
}
